$(document).ready(function(){
    function toggleGenerator(fromClick, toToggle, toClass) {
        $(fromClick).click(function () {
            $(toToggle).toggleClass(toClass);
        });
    }

    toggleGenerator(".pendientes__listado", ".pendientes", "pendientes--toggle");

    $(".paseye").click(function(e){
    e.preventDefault();
    var input = $(this).parent().find("input");
        if (input.attr('type') == "password") {
            input.attr("type", "text");
            $(".paseye").addClass("paseye--close");
            $(".paseye").html("OCULTAR");
        }
        else{
            input.attr("type", "password");
            $(".paseye").removeClass("paseye--close");
            $(".paseye").html("MOSTRAR");
        }

    });
    $("#SiDistri").click(function(){
        $(".distribui").fadeIn();
        $(".distriopciones--active").removeClass("distriopciones--active");
        $(this).addClass("distriopciones--active");
    });
    $("#NoDistri").click(function(){
        $(".distribui").fadeOut();
        $(".distriopciones--active").removeClass("distriopciones--active");
        $(this).addClass("distriopciones--active");
        window.location = '/dashboard';
    });
    $(".ddrop__trigger").on("click", function(){
        //$(".ddrop__content").fadeOut();
        $(this).parent().find(".ddrop__content").fadeToggle();
        $(this).parent().find(".avatar").toggleClass("avatar--active");
        $(this).parent().find(".ddrop__trigger").toggleClass("ddrop__trigger--active");
    });
    $(".mainheader__trigger, .asidebar__close").click(function(){
        $(".asidebar").fadeToggle();
    });
});


// http://jsfiddle.net/hnco3Lfq/
$('#cta-num-select').on('input', function() {
    var noi = +$(this).val() || 0;
    noi = noi < 1 ? 1 : noi;

    var e = $('.dup-block__item'),
        $first = e.first();
    e.slice(noi).remove();
    for (var i = e.length; i < noi; i++) {
        $first.clone().insertAfter('.dup-block__item:last');
    }
}).trigger('change');
$('.item-chooser').on('input', function() {
    var $this = $(this),
        $container = $this.closest('.dup-block__item'),
        option = $this.val();
    $container.find('.cta-option').slideUp();
    $container.find('.cta-option-' + option).stop(true).slideDown();
}).trigger('change');
$(".publi__radios input").on("input", function(e){
    e.preventDefault();
    var leid = $(this).attr("id");
    console.log(leid);
    $(this).parent().parent().find(".publi__radios--active").removeClass("publi__radios--active");
    $(this).parent().addClass("publi__radios--active");
    $(".publi__cont--tab").hide();
    $("[data-item="+leid+"]").fadeIn();
});

$(".publi__mas").click(function (e) {
    e.preventDefault();
    var inpt = $(this).parent().find('input');
    var valor = parseInt(inpt.val());
    inpt.val(valor+1);
    if((valor+1)>0){
        $(this).parent().find('.form__menos').removeClass("disabled");
    }

}).trigger('change');

$(".publi__menos").click(function (e) {
    e.preventDefault();
    var inpt = $(this).parent().find('input');
    var valor = parseInt(inpt.val());

    if (valor > 0) {
        inpt.val(valor-1);
        if((valor-1)===0){
            $(this).addClass("disabled");
        }
    }
}).trigger('change');
$("[data-title]").on("input", function(){
    var name = $(this).val();
    $(".titname").html(" " + name)
});

$(document).scroll(function(){
    var scltp = $(window).scrollTop();
    if(scltp > 80){
        $("body").addClass("scrl");
    }
    else{
        $("body").removeClass("scrl");
    }
});
$(".input__check input").on("input",function(){
    if($(this).is(':checked')){
        $(this).parent().addClass("input--checked");
    }
    else{
        $(this).parent().removeClass("input--checked");
    }
});

window.flashGrowl = function (message) {
    window.dispatchEvent(new CustomEvent('show-success-growl', {
        detail: {
            message: message,
        }
    }));
}
